import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';
import { ListaModelos } from './ListaModelos';
import { ModeloForm } from './ModeloForm';

const Stack = createStackNavigator();

export function ModeloMensagemStack() {
  return (
    <Stack.Navigator
      initialRouteName="ListaModelos"
      screenOptions={{
        headerShown: true,
        headerStyle: {
          elevation: 0,
          shadowOpacity: 0,
          borderBottomWidth: 0,
        },
      }}
    >
      <Stack.Screen 
        name="ListaModelos" 
        component={ListaModelos} 
        options={{ title: 'Modelos de Mensagem' }} 
      />
      <Stack.Screen 
        name="NovoModelo" 
        component={ModeloForm} 
        options={{ title: 'Novo Modelo' }} 
      />
      <Stack.Screen 
        name="EditarModelo" 
        component={ModeloForm} 
        options={{ title: 'Editar Modelo' }} 
      />
    </Stack.Navigator>
  );
}

export * from './ListaModelos';
export * from './ModeloForm';
